import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useSearchHandler } from 'decorators/withSearchHandler';
import { H1, H2 } from 'components/core/Typography';
import { SearchBox } from 'components/search/SearchBox';

import './landingHero.scss';

export function LandingHero({
	className, dark, handleSearch: handleSearchProp, headline, subheading, children, withSearchBox = true, withDatePicker,
	searchButtonText, searchType, searchParams, searchPath
}) {
	const { handleSearch: hookHandleSearch } = useSearchHandler({ searchType, searchParams, searchPath });
	const handleSearch = handleSearchProp || hookHandleSearch;
	return (
		<div className={classnames('landing-hero', className, { dark })}>
			<div className="section-content">
				{!!headline &&
					<H1
						color="white"
						size="huge"
					>
						{headline}
					</H1>
				}
				{!!subheading &&
					<H2
						color="white"
						weight="medium"
						size="medium"
					>
						{subheading}
					</H2>
				}
				{!!withSearchBox &&
					<SearchBox
						withDatePicker={withDatePicker}
						handleSearch={handleSearch}
						buttonText={searchButtonText}
						id="psp-landing-hero-search"
					/>
				}
				{children}
			</div>
		</div>
	);
}

LandingHero.propTypes = {
	searchButtonText: PropTypes.string,
	className: PropTypes.string,
	handleSearch: PropTypes.func,
	headline: PropTypes.node,
	subheading: PropTypes.node,
	children: PropTypes.node,
	dark: PropTypes.bool,
	withSearchBox: PropTypes.bool,
	withDatePicker: PropTypes.bool,
	searchType: PropTypes.string,
	searchParams: PropTypes.object,
	searchPath: PropTypes.string
};

export default LandingHero;
